import { Environment } from "../enums/environment";
import { Region } from "../enums/region";

export const OfflineCacheUserInfoStaleTime = 1440;

export const OfflineCacheUserInfoExpiryTime = 1440;

export const OfflineCacheHttpServiceWorkerCache = 'ps-mfe-http-service-worker-cache';

export const STUDENT = 'STUDENT';

export const PARENT = 'PARENT';

export const DetailFees = 'detail-fees';

export const DetailEcollect = 'detail-ecollect';

export const ContainerName = 'appshell-mfe';

export const UserTypeHint = '_userTypeHint';

export const OverViewMenuId = 'ch-nav';

export const OverViewDashboardMenuId = 'appshell-dashboard';

export const HeaderMFEId = 'appshell-header';

export const DefaultLocale = 'en-US';

export const DefaultLanguage = 'en';

export const DefaultCountry = 'US';

export const ProductCode = 'MyPS';

// Specifying gainsight because this portal is supporting parent,student and guardian.
// Based on application needs we might use different persona.
export const GainSightPortal = 'Student';

export const DashboardServer: Record<Environment, Record<Region, string>> = {
  [Environment.PROD]: {
    [Region.DEFAULT]: 'https://dashboard.student.powerschool.com',
    [Region.CA]: 'https://dashboard.student.ca.powerschool.com'
  },
  [Environment.STG]: {
    [Region.DEFAULT]: 'https://dashboard.stgus.student.powerschoolcorp.com',
    [Region.CA]: 'https://dashboard.stgus.student.ca.powerschoolcorp.com'
  },
  [Environment.INT]: {
    [Region.DEFAULT]: 'https://dashboard.int.student.powerschoolcorp.com',
    [Region.CA]: 'https://dashboard.int.student.ca.powerschoolcorp.com'
  }
};

export const SchoolIdLabel = 'sch';

export const DistrictIdLabel = 'dir';

export const AddressLine1 = '-address-line1';

export const AddressLine2 = '-address-line2';

export const AddressLine3 = '-address-line3';

export const AddressLine4 = '-address-line4';

export const CacheNamePrefix = 'ps-mfe';

export const MyPathwaysMFEId = 'mfe-nav-wf-mypathways';

export const validMfeTypeForRouting = 'WF';

export const sessionWaringTimeInMin = 25;

export const sessionLogoutTimeInMin = 5;

export const GainsightUidCookie = 'apt.uid';

export const GainsightSidCookie = 'apt.sid';

export const GlobalCode = 'GB';

export const PageNotFoundStatusCode = "404";

export const DetailGradesMenuId = 'detail-grades';

export const GraduationPlanProgressLabel = 'Graduation Plan Progress';

export const DetailGradesSubmenuGrades = 'detail-grades-submenu-grades';

export const DetailGradesSubmenuGPPId = 'detail-grades-submenu-graduation-plan-progress';

export const DirectoryMFEId = 'user-directory';

export const CollegePlanningMFE = 'college-planning';

export const PostNewsFeedMFE = 'post-newsfeed';

export const CALENDAR = 'calendar';

export const NEWSFEED = 'newsfeed';

export const DIRECTORY = 'directory';

export const EDUCATORPORTAL = 'educator';

export const GUARDIANPORTAL = 'guardian';

export const STUDENTPORTAL = 'student';

export const DefaultErrorMessage = 'We have an internal server error while processing the request.';

export const DirectoryMFELeftNavName = 'Directory';

export const NewsfeedMFELeftNavName = 'Newsfeed';

export const CustomLinks = 'custom-links';

export const SelectedStudentLocalStorageName = 'selected-student';

export const NoFooterLayout = 'no-footer';

export const StandardLayout = 'standard';

export const ApplicationMenuMFEId = 'application-menu';

export const SMHomeInboxMFEId = 'sm-home-inbox';

export const SchoolMessengerMFEId = 'schoolmessenger-inbox'; 

export const MPHStudentLogoutTag = 'mph-student.logout';

export const DetailAssignmentsMFEId = 'detail-assignments';

export const PTGradesMFEId = 'pt-grades';

export const DetailGradeHistoryMFEId = 'detail-grade-history';

export const StandardGradesMFEId = 'detail-standards-grade-list';

export const PowerBuddyMFEId = 'ph-ai-chatbot';

export const AccountManagementMFEId = 'account-management';

export const MessengerInboxMFEId = 'messenger-inbox';

export const DetailsSgyAssignmentsMFEId = 'detail-sgy-assignments';

export const AssignmentLabel = 'assignment';

export const AssignmentsLabel = 'assignments';

export const GradebookAssignmentsLabel = 'gradebook assignments';

export const SGYAssignmentIcon = 'app-nav-assignments';

export const AppShellId = 'application-shell';

export const NeonFunEnabledLocalStorageName = 'neon-fun-enabled';